let env = null;

import prod from './prod.js'
import dev from './dev.js'
import staging from './staging.js'

if (process.env.NODE_ENV === 'development') {
  env = dev;
} else if (process.env.NODE_ENV === 'staging') {
  env = staging;
} else if (process.env.NODE_ENV === 'production') {
  env = prod;
}

export default env




// WEBPACK FOOTER //
// ./src/config/loadEnv.js